<template>
  <div class="modal" v-bind:class="{ 'is-active': is_shown }">
    <div class="modal-background" @click="close_modal"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t("change password") }}</p>
        <button class="delete" aria-label="close" @click="close_modal"></button>
      </header>
      <section class="modal-card-body">
        <form>
          <div class="field">
            <label class="label">{{ $t("current password") }}</label>
            <div class="control">
              <input
                class="input"
                type="password"
                :placeholder="$t('enter current password')"
                v-model="meta.current_password"
              />
            </div>
          </div>
          <div class="field">
            <label class="label">{{ $t("new password") }}</label>
            <div class="control">
              <input
                class="input"
                v-bind:class="{
                  'is-danger': meta.new_password !== meta.confirm_password,
                }"
                type="password"
                :placeholder="$t('enter new password')"
                v-model="meta.new_password"
              />
            </div>
          </div>
          <div class="field">
            <label class="label">{{ $t("confirm password") }}</label>
            <div class="control">
              <input
                class="input"
                v-bind:class="{
                  'is-danger': meta.new_password !== meta.confirm_password,
                }"
                type="password"
                :placeholder="$t('confirm password')"
                v-model="meta.confirm_password"
              />
            </div>
          </div>
          <div class="notification is-info mt-5 is-dark">
            <div class="title is-6 mb-3">
              {{ $t("password requirements") }}
            </div>
            <ul>
              <li
                v-if="
                  user_data &&
                  user_data.enterprise_settings &&
                  user_data.enterprise_settings.password_min_length
                "
              >
                {{ $t("minimum characters length") }}:
                {{ user_data.enterprise_settings.password_min_length }}
              </li>
              <li
                v-if="
                  user_data &&
                  user_data.enterprise_settings &&
                  user_data.enterprise_settings.password_must_have_number
                "
              >
                {{ $t("at least 1 number") }}
              </li>
              <li
                v-if="
                  user_data &&
                  user_data.enterprise_settings &&
                  user_data.enterprise_settings.password_must_have_uppercase
                "
              >
                {{ $t("at least 1 uppercase letter") }}
              </li>
              <li
                v-if="
                  user_data &&
                  user_data.enterprise_settings &&
                  user_data.enterprise_settings
                    .password_must_have_special_character
                "
              >
                {{ $t("at least 1 special character") }}
              </li>
            </ul>
          </div>
        </form>
        <div class="notification is-danger mt-5" v-if="error">
          <p v-html="error"></p>
        </div>
      </section>
      <footer class="modal-card-foot">
        <p class="buttons">
          <button
            class="button is-primary is-rounded"
            :disabled="
              !meta.new_password ||
              !meta.confirm_password ||
              meta.new_password != meta.confirm_password ||
              pass_requirements(meta.new_password) === false
            "
            @click="update_password"
          >
            <span class="icon">
              <i class="fa fa-save"></i>
            </span>
            <span>{{ $t("update password") }}</span>
          </button>
          <button class="button is-rounded" @click="close_modal">
            {{ $t("cancel") }}
          </button>
        </p>
      </footer>
    </div>
  </div>
</template>
<script>
import { put, generate_error_message_text, get_user_data } from "@/utils";
import jssha1 from "js-sha1";

export default {
  name: "ChangePasswordModal",
  data() {
    return {
      is_shown: false,
      meta: {},
      error: "",
    };
  },
  computed: {
    user_data() {
      return get_user_data();
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.is_shown = false;
      v.set_initial_state();
    },
    show_modal() {
      let v = this;
      v.is_shown = true;
      v.set_initial_state();
    },
    update_password() {
      let v = this;
      // console.log("update_password");
      put("/system/authentication/change-password", {
        current_password: jssha1(v.meta.current_password),
        new_password: jssha1(v.meta.new_password),
      })
        .then(() => {
          v.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      this.meta = {
        current_password: "",
        new_password: "",
        confirm_password: "",
      };
      this.error = "";
    },
    pass_requirements(password) {
      let enterprise_settings = this.user_data?.enterprise_settings;
      if (!enterprise_settings) return true;

      if (
        enterprise_settings.password_min_length &&
        password.length < enterprise_settings.password_min_length
      ) {
        return false;
      }
      if (
        enterprise_settings.password_must_have_number &&
        !/\d/.test(password)
      ) {
        return false;
      }
      if (
        enterprise_settings.password_must_have_uppercase &&
        !/[A-Z]/.test(password)
      ) {
        return false;
      }
      if (
        enterprise_settings.password_must_have_special_character &&
        !/[!@#$%^&*(),.?":{}|<>]/.test(password)
      ) {
        return false;
      }
      return true;
    },
  },
  mounted() {},
};
</script>
<style></style>
